{
  "title": "Score Submission Failed",
  "description": "Troubleshooting steps for when clicking \"Submit\" on a score doesn't go through.",
  "headings": [
    "Symptom",
    "Most Common Causes",
    "Troubleshooting Steps",
    "Expected Result",
    "Still Stuck"
  ],
  "symptom": "Clicking \"Save Draft\" or \"Submit\" produces an error, and the score cannot be saved or submitted.",
  "causes": [
    "Not every rubric item has a score filled in",
    "A score falls outside the range that rubric item allows",
    "This competition requires a review comment and it's still blank",
    "A conflict of interest has been declared for this submission",
    "The assignment is already marked \"Completed\" and needs the organizer to reopen it"
  ],
  "diagnosis": [
    {
      "title": "Step 1",
      "description": "Confirm every rubric item on the scoring form has a score filled in, with none missing or duplicated."
    },
    {
      "title": "Step 2",
      "description": "Confirm every score falls within the range shown for that rubric item."
    },
    {
      "title": "Step 3",
      "description": "If the screen requires a \"Review Comment\" (a per-competition setting), confirm you've entered non-blank text."
    },
    {
      "title": "Step 4",
      "description": "Confirm you haven't declared a conflict of interest against this submission yourself; if you have, scoring is rejected by the server by design — this is the intended protection, not a bug."
    },
    {
      "title": "Step 5",
      "description": "If you already submitted a score for this assignment once before, its status becomes \"Completed\" — ask the organizer to \"reopen\" that score before you can edit and resubmit it."
    }
  ],
  "resolution": "Once the above is resolved, \"Save Draft\" and \"Submit\" should work normally.",
  "stillStuck": [
    "Competition name",
    "Submission's anonymous code",
    "When it happened",
    "Error message",
    "Screenshot"
  ],
  "doNotProvide": ["Password", "Verification code", "Token"],
  "nextSteps": "If it's still stuck after checking the above, see \"How to Score and Formally Submit\" and walk through the full process again."
}
